/* eslint-disable camelcase */
import { call, put, takeLatest } from 'redux-saga/effects';

import { ROUTES, API } from 'utils/Apis';
import { checkStatusCodeApi } from 'utils/Helpers';

import { Types } from '../redux';

// worker Saga: will be fired on SIGN_UP_ACCOUNT actions
function* deleteComment(action) {
  try {
    /**
     * Example data
     * url: enpoint/register
     *
     */
    const response = yield call(() =>
      API.post(ROUTES.API_DELETE_COMMENT, action.data)
    );

    if (response.ok) {
      const { data } = response;
      // In case: signup request success
      yield put({
        type: Types.DELETE_COMMENT_SUCCESS,
        data,
        params: action?.data,
      });
    } else {
      const { data } = response;
      checkStatusCodeApi(data?.code || null)

      yield put({
        type: Types.DELETE_COMMENT_FAILED,
      });
    }
  } catch (error) {
    // in case: server error
    yield put({ type: Types.DELETE_COMMENT_FAILED, error });
  }
}

/*
  Starts deleteComment on each dispatched `DELETE_COMMENT` action.
*/
function* deleteCommentSaga() {
  yield takeLatest(Types.DELETE_COMMENT, deleteComment);
}

export default deleteCommentSaga;
